<template>
  <v-img
    aspect-ratio="1"
    :height="`${size}px`"
    :width="`${size}px`"
    :lazy-src="emptyPlaceholderImage"
    :src="url ? fitImage(url, size, size) : placeholderImage"
    :srcset="url ? getSrcset(url, size, size) : placeholderImage"
    class="rounded"
    :alt="title"
  >
    <slot />
  </v-img>
</template>

<script setup lang="ts">
import { emptyPlaceholderImage, fitImage, getSrcset, placeholderImage } from '@/helpers'
import { t } from '@/plugins/i18n'

defineProps({
  url: {
    type: String,
    default: undefined
  },
  size: {
    type: Number,
    default: 100
  },
  title: {
    type: String,
    default: t('noImageAvailable')
  }
})
</script>
